export default __webpack_public_path__ + "static/garden_design19-5ba2945cf94ca524f827d28eadec8886.webp";